import styled from "styled-components";

import checkImg from "../../images/icon_check.svg";
import { TOOLTIPS } from "../../utils/tooltipConstants";
import { BaseButton, TooltipBox } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.accentGreen};
  & :hover > ${TooltipBox} {
    background-color: ${({ theme }) => theme.colors.accentGreen};
  }
`;

export function ApproveButton(props) {
  const { tooltipText, onClick } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.approve.text;
  return (
    <IconButton onClick={onClick} tooltip={tooltipContent}>
      <img src={checkImg} alt={tooltipContent} />
    </IconButton>
  );
}
